<template>
  <div class="c-process-step-summary">
    <affix relative-element-selector="#content-primary" style="width: 250px">
      <h2 class="c-process-step-summary__process-name t-margin-bottom-s">
        {{ processName }}
      </h2>
      <h2
        class="c-process-step-summary__title t-margin-bottom-s"
        v-if="processSteps.length > 0"
      >
        Steg i processen
      </h2>
      <div
        class="c-process-step-summary__container"
        v-scroll-spy-active="{
          selector: '.c-process-step-summary__name',
          class: 'c-process-step-summary__active'
        }"
        v-scroll-spy-link
      >
        <template v-for="(step, index) in processSteps">
          <div
            class="c-process-step-summary__wrapper"
            v-scroll-to="{ el: '#step-' + step.id }"
          >
            <div class="c-process-step-summary__link">
              <span
                class="c-process-step-summary__circle"
                v-bind:class="{
                  'c-process-step-hide__circle': step.status === 'Unpublished'
                }"
              >
                <span class="c-process-step-summary-circle__numbers">{{
                  step.number
                }}</span>
              </span>
              <span class="c-process-step-summary__name">{{ step.name }}</span>
            </div>
            <span
              v-if="
                processSteps.length > 1 && index !== processSteps.length - 1
              "
              class="c-process-step-summary__line"
            ></span>
          </div>
        </template>
      </div>
    </affix>
  </div>
</template>

<script>
export default {
  name: 'ProcessStepSummary',
  props: {
    processName: {
      type: String,
      default: ''
    },
    processSteps: {
      type: Array,
      default: () => []
    }
  }
};
</script>
